/*
 * @Auther: 罗耀祖
 * @Date: 2021-11-09 09:38:42
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-08 19:04:56
 * @name: 装饰器
 * @Description: 装饰器
 * @FilePath: \project\src\utils\decorator.js
 * @Author: desktop
 */
import { debounce } from "lodash";
import { MessageBox } from "element-ui";

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 防抖
 * @param {Number} delay 延迟时间(ms)
 * @param {Boolean} leading 指定在延迟开始前调用
 * @param {Boolean} trailing 指定在延迟结束后调用
 */
export function debounceation(delay = 300, leading = true, trailing = false) {
  return function (target, name, descriptor) {
    let oldValue = descriptor.value;
    descriptor.value = debounce(function (...args) {
      return oldValue.call(this, ...args)
    }, delay, { leading, trailing })
    return descriptor;
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 弹窗确认
 * @param {String | Function} message 提示信息,String类型时,直接作为提示语,Function类型时,作为回调函数,执行获取提示语句 
 * @param {String} type element-ui messageBox 提示类型
 */
export function confirmation(message, type = 'warning') {
  return function (target, name, descriptor) {
    let oldValue = descriptor.value;
    descriptor.value = async function (...args) {
      let myMsg = '';
      if (typeof (message) === 'function') {
        myMsg = message(...args);
      } else {
        myMsg = message;
      }
      const func = () => {
        return new Promise((resolve, reject) => {
          MessageBox.confirm(myMsg, '提示', {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type,
          })
            .then(() => { resolve(true) })
            .catch(() => { });
        })
      }
      if(await func()) return oldValue.call(this, ...args);
    };
    return descriptor;
  }
}